import { MutationTree } from "vuex";
import { IOtherAppointmentState } from "./state";

import {
    EDIT_OTHER_APPOINTMENT,
    DELETE, ADD_OTHER_APPOINTMENTS,
    ADD_OTHER_APPOINTMENT,
    SET_SELECTED_OTHER_APPOINTMENT,
} from "./mutations-types";
import { IOtherAppointment, IOtherAppointmentSlot } from "@/models";
import Vue from "vue";

export const mutations: MutationTree<IOtherAppointmentState> = {
    [EDIT_OTHER_APPOINTMENT](state, payload: IOtherAppointment): void {
        const index = state.otherApointments.findIndex(oa => oa.otherAppointment.otherAppointmentId === payload.otherAppointmentId);

        Vue.set(state.otherApointments, index, { slotId: payload.slotId, otherAppointment: payload});
    },

    [DELETE](state, id: number): void {
        const index = state.otherApointments.findIndex(oa => oa.otherAppointment.otherAppointmentId === id);

        state.otherApointments.splice(index, 1);
    },

    [ADD_OTHER_APPOINTMENTS](state, payload: IOtherAppointmentSlot[]): void {
        state.otherApointments = payload;
    },

    [ADD_OTHER_APPOINTMENT](state, payload: IOtherAppointment): void {
        state.otherApointments.push({ slotId: payload.slotId, otherAppointment: payload });
    },

    [SET_SELECTED_OTHER_APPOINTMENT](state, payload: IOtherAppointmentSlot): void {
        state.selectedOtherAppointment = payload;
    },
};
